import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const SuccessIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 16 16"
    width={width}
    {...restProps}
  >
    <g>
      <path d="M1.41,7.35l0,0a1.39,1.39,0,0,1,2,0l3,3,6-6.85a1.4,1.4,0,1,1,2.11,1.84l-7.14,7.9a1.41,1.41,0,0,1-2,.06l-4-4a1.39,1.39,0,0,1,0-2"/>
    </g>
  </Icon>
  /* eslint-enable */
);

SuccessIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default SuccessIcon;
